// components/NavBar.tsx
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import authService from 'services/auth.service';
import ReceptionModal from './_common/modal/ReceptionModal';
import { ReceptionDTO } from 'models/reception';
import PageUtil from 'utils/Page.util';
import receptionService from 'services/reception.service';
import { getMenus } from 'models/admin';

class Params {
    isMember: boolean = false;
    items: Array<any> = [];
}

function NavBar() {
    const navigate = useNavigate();
    const [params, setParams] = useState(new Params());
    const [mounted, setMounted] = useState(false);
    const [menuPermissions, setMenuPermissions] = useState<string[]>([]);

    // 모달 상태 관리 추가
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState<'create' | 'edit'>('create');
    const [editingRow, setEditingRow] = useState<ReceptionDTO | null>(null);

    //onMount
    useEffect(() => {
        console.log('NavBar onMount');

        // 토큰에서 메뉴 권한 정보 추출
        const token = authService.getToken();
        if (token) {
            const permissions = token?.info?.menus || [];
            const roles = token.roles || [];

            // master 권한은 모든 메뉴 접근 가능
            if (roles.includes('master')) {
                setMenuPermissions(getMenus().map(menu => menu.path));
            } else {
                setMenuPermissions(permissions);
            }
        }

        setMounted(true);
    }, []);

    function openMember() {
        setParams((prev) => ({
            ...prev,
            isMember: !prev.isMember,
            isLang: false,
            isNoti: false,
        }));
    }

    async function signOut() {
        await authService.signOut(true);
        navigate('/login?r=' + location.pathname);
    }

    /** 신규 접수 모달 열기 */
    function onOpenCreate() {
        setModalMode('create');
        setEditingRow(null);
        setShowModal(true);
    }

    /** 모달에서 저장 완료 시 */
    async function onModalSave(reception: ReceptionDTO, close: boolean = true) {
        try {
            console.log("close", close);
            console.log("reception", reception);
            await receptionService.save(reception);
            if (close) setShowModal(false);
            alert('저장되었습니다.');
            // 필요시 목록 새로고침 등 추가 처리
        } catch (error) {
            console.error('접수 저장 실패:', error);
            alert('저장에 실패했습니다.');
        }
    }

    /** 모달 닫기 */
    function onModalClose() {
        setShowModal(false);
        setEditingRow(null);
    }

    /** 메뉴 접근 권한 확인 */
    const hasMenuPermission = (menuPath: string): boolean => {
        return menuPermissions.includes(menuPath);
    };

    /** 페이지 이동 핸들러 */
    const handleNavigate = (path: string) => {
        navigate(path);
        openMember(); // 메뉴 닫기
    };

    return (
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
            {mounted && (
                <>
                    <ul className="navbar-nav">
                        <li className="nav-item relative">
                            <a className="nav-link ic_expend" data-widget="pushmenu" href="#" role="button">
                                <i className="fas fa-bars"></i>
                            </a>
                        </li>
                    </ul>

                    <ul className="navbar-nav util">
                        <li>
                            <button className="btn btn-primary" onClick={onOpenCreate}>
                                + 접수등록
                            </button>
                        </li>
                        <li>
                            <span className="ic_text member" onClick={openMember}>
                                {authService.getUserId()}
                            </span>
                            {params.isMember && (
                                <div className="sub_layer">
                                    <ul>
                                        <li>
                                            <button className="g_button" onClick={signOut}>
                                                로그아웃
                                            </button>
                                        </li>

                                        {/* 관리자 관리 - 권한 체크 */}
                                        {hasMenuPermission('/admin') && (
                                            <li>
                                                <button
                                                    className="g_button"
                                                    onClick={() => handleNavigate('/admin')}
                                                >
                                                    관리자 관리
                                                </button>
                                            </li>
                                        )}

                                        {/* 상품 관리 - 권한 체크 */}
                                        {hasMenuPermission('/product') && (
                                            <li>
                                                <button
                                                    className="g_button"
                                                    onClick={() => handleNavigate('/product')}
                                                >
                                                    상품 관리
                                                </button>
                                            </li>
                                        )}

                                        {/* 출장비 관리 - 권한 체크 */}
                                        {hasMenuPermission('/trip-fee') && (
                                            <li>
                                                <button
                                                    className="g_button"
                                                    onClick={() => handleNavigate('/trip-fee')}
                                                >
                                                    출장비 관리
                                                </button>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </li>
                    </ul>

                    {/* 접수 등록/수정 모달 */}
                    <ReceptionModal
                        show={showModal}
                        title={modalMode === 'create' ? '신규 접수 등록' : '접수 수정'}
                        initial={editingRow}
                        onSave={onModalSave}
                        onClose={onModalClose}
                    />
                </>
            )}
        </nav>
    );
}

export default NavBar;